interface RetornoObjFilaJson {
  id_pc: number;
  nome_ug: string;
  situacao: string;
  ds_situacao: string;
  ano: number;
  mes: number;
  id_sistema: number;
  ds_sistema: string;
  dt_entrega: string;
}
interface RetornoObjProcessadasJson {
  id_sistema: number;
  ds_sistema: string;
  qtd: number;
  mes: number;
}
interface RetornoObjObrigadasJson {
  id_sistema: number;
  ds_sistema: string;
  qtd: number;
}
export interface RetornoFilaPCMJson {
  fila: RetornoObjFilaJson[];
  processadas: RetornoObjProcessadasJson[];
  obrigadas: RetornoObjObrigadasJson[];
}
export class FilaPCM {
  id_pc: number;
  nome_ug: string;
  situacao: string;
  ds_situacao: string;
  ano: number;
  mes: number;
  id_sistema: number;
  ds_sistema: string;
  dt_entrega: Date;

  constructor(obj?: RetornoObjFilaJson) {
    if (obj) {
      this.id_pc = obj.id_pc;
      this.nome_ug = obj.nome_ug;
      this.situacao = obj.situacao;
      this.ds_situacao = obj.ds_situacao;
      this.ano = obj.ano;
      this.mes = obj.mes;
      this.id_sistema = obj.id_sistema;
      this.ds_sistema = obj.ds_sistema;
      this.dt_entrega = new Date(obj.dt_entrega);
    }
  }
}
export class ProcessadasPCM {
  id_sistema: number;
  ds_sistema: string;
  qtd: number;
  mes: number;

  constructor(obj?: RetornoObjProcessadasJson) {
    if (obj) {
      this.id_sistema = obj.id_sistema;
      this.ds_sistema = obj.ds_sistema;
      this.qtd = obj.qtd;
      this.mes = obj.mes;
    }
  }
}
export class ObrigatoriasPCM {
  id_sistema: number;
  ds_sistema: string;
  qtd: number;

  constructor(obj?: RetornoObjObrigadasJson, mesesExecucao?: number, mesesRestantes?: number) {
    if (obj) {
      const multiplier = (obj.id_sistema === 1 ? mesesExecucao : mesesRestantes) || 1;
      this.id_sistema = obj.id_sistema;
      this.ds_sistema = obj.ds_sistema;
      this.qtd = obj.qtd * multiplier;
    }
  }
}

export class RetornoFilaPCM {
  anoInicial: number;
  anoFinal: number;
  mesInicial: number;
  mesFinal: number;

  fila: FilaPCM[];
  processadas: ProcessadasPCM[];
  obrigadas: ObrigatoriasPCM[];


  constructor(ano: number, mesInicial: number, mesFinal: number, obj?: RetornoFilaPCMJson) {
    if( ano ) {
      this.anoInicial = ano;
      this.anoFinal = ano;
    }
    if( mesInicial ) this.mesInicial = mesInicial;
    if( mesFinal ) this.mesFinal = mesFinal;

    const mesesExecucao = mesFinal - mesInicial + 1;
    const mesesRestantes = mesFinal > 12 ? 13 - mesInicial : mesFinal - mesInicial + 1;
    
    this.fila = [];
    this.processadas = [];
    this.obrigadas = [];

    if (obj) {
      this.fila = obj.fila.map((f) => new FilaPCM(f));
      const mergedProcessadas = obj.processadas.reduce((acc, curr) => {
        const found = acc.find(item => item.id_sistema === curr.id_sistema);
        if (found) {
          found.qtd += curr.qtd;
        } else {
          acc.push({ ...curr });
        }
        return acc;
      }, [] as RetornoObjProcessadasJson[])
      this.processadas = mergedProcessadas.map((p) => new ProcessadasPCM(p));
      this.obrigadas = obj.obrigadas.map((o) => new ObrigatoriasPCM(o, mesesExecucao, mesesRestantes));
    }
  }
}
